'use client';
import type { UserOnboardingPrimary } from '@/types/zones/slices/user-onboarding';
import dynamic from 'next/dynamic';
import { getConfig } from '@/utils/config/config';
import { getGame } from '@/logic/game-info/game-info';
import { useStore } from '@/store/store';
import { POPUPS } from '@/app/components/popup/constants';
import { useGlobalContext } from '@/store/contexts/global-context';
import { PRODUCT_THROTTLES } from '@/utils/feature-flags/constants';
import './styles/@theme';

const WelcomeLobbyMessageUM = dynamic(
    () => import('@fanduel/casino-user-profile-web').then((m) => m.WelcomeLobbyMessage),
    { ssr: false }
);

export const WelcomeLobbyMessage = (props: { data: UserOnboardingPrimary; platform?: string; product?: string }) => {
    const config = getConfig();
    const webOrigin = `${config.apis.AggregationDataClient.protocol ?? 'https'}://${config.apis.AggregationDataClient.host ?? config.domain}`;
    const launcherOrigin = `${config.apis.LauncherClient.protocol ?? 'https'}://${config.apis.LauncherClient.host}`;
    const { queuePopup } = useStore((s) => s.popup);
    const { featureFlags } = useGlobalContext();

    const handleGameInfoClick = async (gameUid: string) => {
        const game = await getGame(gameUid);
        if (!game?.uid) return;
        queuePopup({ type: POPUPS.GAME_INFO, params: game });
    };

    return (
        <div className="welcome-lobby-message-zone">
            <WelcomeLobbyMessageUM
                title={props.data?.welcome_title?.[0]?.text ?? ''}
                cta={props.data?.avatar_cta?.[0]?.text ?? ''}
                webOrigin={webOrigin}
                launcherOrigin={launcherOrigin}
                platform={props.platform}
                product={props.product}
                onGameInfoClick={handleGameInfoClick}
                hasFavouriteGamesIcon={featureFlags[PRODUCT_THROTTLES.FAVOURITE_GAMES]}
            />
        </div>
    );
};
